// removed by extract-text-webpack-plugin
module.exports = {"Card":"_1_26GvX9QDcsX1UYPpHt4R","CardData":"_1ijovNYt3ndTi343nRjNhx","Country":"_2oDnK4AGywTXqSzaJTrCmi","DateLabel":"epQ7tuAcxLF2oSZZTQOdw","Date":"_2LCk-M_hIWrObAmsoJ0ner","Numbers":"_1T4RaiLTFTk9pn_Xj5Rzo_","Blurb":"_1KgHGz8Lhxn2gx9pN-Kk2y"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Card/Card.css
// module id = 109
// module chunks = 0